import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import type { SessionUser } from '@simsm/shared-types';
import { apiClient } from '../app/api-client';
import { markSessionEstablished } from '../app/session-presence';

async function fetchSession(): Promise<SessionUser | null> {
  try {
    const response = await apiClient.get<SessionUser>('/auth/session');
    // Remembering that this browser has held a session is what lets a later 401
    // say "the session expired" instead of guessing (see session-presence.ts).
    markSessionEstablished();
    return response.data;
  } catch (error) {
    if (
      typeof error === 'object' &&
      error !== null &&
      'status' in error &&
      (error as { status: number }).status === 401
    ) {
      return null;
    }
    throw error;
  }
}

export function useSession(): UseQueryResult<SessionUser | null> {
  return useQuery({
    queryKey: ['session'],
    queryFn: fetchSession,
    staleTime: 60_000,
    retry: false,
  });
}
